export default __webpack_public_path__ + "static/media/myaccount_white.83265cce.svg";